module.exports = {
    "collapse": `Restr\xe2nge\u{21B}i`,
    "expand": `Extinde\u{21B}i`
};


//# sourceMappingURL=ro-RO.main.js.map
